// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AgentStreamController from "./agent_stream_controller"
application.register("agent-stream", AgentStreamController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import BaseViewerController from "./base_viewer_controller"
application.register("base-viewer", BaseViewerController)

import BeaconController from "./beacon_controller"
application.register("beacon", BeaconController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import DocumentViewerController from "./document_viewer_controller"
application.register("document-viewer", DocumentViewerController)

import DragAndDropController from "./drag_and_drop_controller"
application.register("drag-and-drop", DragAndDropController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ElementRemovalController from "./element_removal_controller"
application.register("element-removal", ElementRemovalController)

import ExcelViewerController from "./excel_viewer_controller"
application.register("excel-viewer", ExcelViewerController)

import FormController from "./form_controller"
application.register("form", FormController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import ImageViewerController from "./image_viewer_controller"
application.register("image-viewer", ImageViewerController)

import LivePreviewController from "./live_preview_controller"
application.register("live-preview", LivePreviewController)

import PdfViewerController from "./pdf_viewer_controller"
application.register("pdf-viewer", PdfViewerController)

import ProgramSelectionController from "./program_selection_controller"
application.register("program-selection", ProgramSelectionController)

import QuotedContentController from "./quoted_content_controller"
application.register("quoted-content", QuotedContentController)

import ScrollBottomController from "./scroll_bottom_controller"
application.register("scroll-bottom", ScrollBottomController)

import SelectBoxController from "./select_box_controller"
application.register("select-box", SelectBoxController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TimezoneCookieController from "./timezone_cookie_controller"
application.register("timezone-cookie", TimezoneCookieController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UploadProgressController from "./upload_progress_controller"
application.register("upload-progress", UploadProgressController)
